import {until} from 'lit-html/directives/until';
import {generalLabels} from '@modules/i18n-labels';

export default (ctx, html) => html`
<div class="text-center py-5 px-4">
  <slot></slot>
</div>

<div class="d-flex justify-content-md-center align-items-center pb-5">
  <div class="col-lg-4 col-md-5 col-sm-7 col-xs-12 mb-2">
    <button type="button" class="btn btn-lg btn-block btn-outline-primary rounded-pill" @click="${ctx.cancel}">${until(generalLabels.cancel)}</button>
  </div>
  <div class="col-md-4 col-sm-5 col-xs-12 mb-2">
    <button ?disabled="${ctx.submitting}" @click=${ctx.submit} type="submit" class="btn btn-lg btn-block btn-primary rounded-pill">${until(ctx.__('<tt-amEb318X>', 'Archive'))}</button>
  </div>
</div>
`;
